module.exports = __webpack_public_path__ + "img/angle-down.02d51d35.svg";